module.exports = __webpack_public_path__ + "sl.svg?58ef1e3b6bff58d6f4ca6047a96fc59d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sl.svg
// module id = 1615
// module chunks = 0